import { startBeacon } from "@kensio/rainlytics/beacon";

import { startArticleWriting } from "./article-writing.js";
import { startCidianAudio } from "./cidian-audio.js";
import { startDownloadOffer } from "./download-offer.js";
import { startLijuCopyButtons } from "./liju-copy.js";
import { startNavMenus } from "./nav-menus.js";
import { startSaveWords } from "./save-word.js";
import { startSignInLink } from "./sign-in-link.js";

/**
 * The script every page loads.
 *
 * **Bootstrap's JavaScript is gone from it.** The navbar collapse and the tools
 * dropdown were the only two things on this site that Bootstrap's JavaScript
 * did, and both are native `<details>` elements now: the browser opens them,
 * and there is nothing left to import. The dropdown was the expensive half,
 * because it is what pulled in Popper to position the menu.
 *
 * That took the bundle from 46,981 bytes to a little over a thousand. It also
 * fixed the defect the imports were there to avoid: below Bootstrap's `lg`
 * breakpoint the bar collapsed to a button that only its JavaScript could open,
 * so a visitor on a phone whose script had not arrived had no way to reach any
 * section of the site from any page on it.
 *
 * Bootstrap's stylesheet is still here. `assets/sass/_vendor.scss` no longer
 * takes its `nav`, `navbar` or `dropdown` partials, those three having had no
 * markup to style once this file changed, but the reboot, the grid, the buttons
 * and the form controls remain and are what the next phase is about.
 *
 * **The 例句 copy buttons.** The one piece of this site's own behaviour in here,
 * and it is here rather than in a bundle of its own because it is a few hundred
 * bytes: a second request on the sentence pages would cost more than carrying it
 * everywhere does. It finds nothing to do on the other thousand pages.
 *
 * **The navigation menus.** Both are native `<details>` and open with no script
 * at all, which is the whole point of them; what this adds is dismissal. A
 * disclosure closes when its own summary is used and at no other time, so
 * without this a reader who opens the tools menu has to find the word "Tools"
 * again to be rid of it. See `nav-menus.ts`.
 *
 * **The sign-in link.** The bar is rendered once for the whole site and served
 * from the edge, so the markup cannot say which page a reader is on. This puts
 * that page on the link, and the callback ends there instead of on the home
 * page. See `sign-in-link.ts`.
 *
 * **The writing an article's prose is drawn in.** A reader who chose 繁體 was
 * getting it in the 例句 and nowhere else, because those are the only Chinese
 * on the site that was ever written more than one way. This redraws the rest
 * from a table the page carries. It is the largest thing in here and still
 * under a kilobyte, and it returns on its first line for the reader who chose
 * 简体 and on every page that is not an article. See `article-writing.ts`.
 *
 * **The vocabulary download gate.** It turns the two HSK list downloads off for
 * a signed-out reader and puts a line offering an account under them, and it is
 * in here on the same argument as the copy buttons. A few hundred bytes that
 * find nothing to do on every page but the thirteen 词典 level listings. The
 * addresses stay on the links and the files stay in the bucket, so this asks a
 * reader in a browser and stops nobody else. See `download-offer.ts`.
 *
 * **The save control.** A 词典 entry carries a button that keeps the word, and
 * the page is served from the edge, so it cannot say whether the reader already
 * holds it. This asks, relabels the ones they do, and takes the press where it
 * stands. Nothing on the control needs it: with the script blocked the form
 * posts and the reader lands on their list. See `save-word.ts`.
 *
 * **The 词典 audio controls.** A pilot hundred of the entries carry a recording
 * of the headword in two voices, and this shows the controls and plays them.
 * It returns on its first line for every page carrying none, which today is
 * every page but those hundred. See `cidian-audio.ts` and `docs/audio.md`.
 *
 * **The analytics beacon.** The site's CloudFront access logs already record
 * every request, and a route change makes none. This reports those to the
 * collection path `BeaconPath` puts on the distribution, which answers 204 at
 * the edge and writes the request into the same log. It is the site's own
 * domain, so there is no second host, no extra connection and no extra
 * download. `lib/site/distribution.ts` has the other half.
 *
 * The page this loads on is not reported. CloudFront already recorded the
 * request that fetched it, and reporting it again would count one view twice.
 *
 * No `DOMContentLoaded` around any of them. The tag in
 * `page-sections/header-start.html` is `type="module"`, which defers, so the
 * document is parsed by the time this runs.
 */
startLijuCopyButtons(document);
startNavMenus(document);
startSignInLink(document, window.location.pathname);
startArticleWriting(document);
startDownloadOffer(document);
startSaveWords(document);

startCidianAudio(document);

startBeacon();
